<div id="content">
  <div class="main-col" *ngIf="isReady(); else loading">
    <ub-card>
      <div title>
        <h1>{{ bookingOption.title }}</h1>
      </div>
     <div content>
      </div>
    </ub-card>

    <ub-card>
      <div title>
        <h2 i18n>Manual changes</h2>
      </div>
      <div actions>
        <eas-buttons-list [buttons]="buttons" [processing]="isOperationInProgress"></eas-buttons-list>
      </div>
      <div content>
        <p i18n>
          A placeholder text for what this above means.
        </p>
        <eas-auditlog-table [dates]="auditlog$ | async"></eas-auditlog-table>
      </div>
    </ub-card>

  </div>
  <ng-template #loading i18n>
    Loading...
  </ng-template>

</div>

